import { ChevronLeft, ChevronRight } from 'lucide-react';
import { Button } from '../ui/Button.js';

/** ‹ Week 40 › — la navigation de semaine, partagée par Upcoming et le Tracker. */
export function WeekNav({
  weekNum,
  isCurrent,
  onPrevious,
  onCurrent,
  onNext,
  nextDisabled = false,
}: {
  weekNum: number;
  isCurrent: boolean;
  onPrevious: () => void;
  onCurrent: () => void;
  onNext: () => void;
  nextDisabled?: boolean;
}): React.ReactElement {
  return (
    <div className="flex items-center gap-1">
      <Button variant="quiet" size="icon-small" onClick={onPrevious} aria-label="Previous week">
        <ChevronLeft size={16} aria-hidden />
      </Button>
      {/* La semaine en cours est un repère, pas un bouton désactivé : grisée, elle avait l'air
          d'une erreur. Ailleurs, le libellé ramène à aujourd'hui. */}
      {isCurrent ? (
        <span className="chiffre text-sm min-w-20 text-center" aria-current="date">
          Week {weekNum}
        </span>
      ) : (
        <Button
          variant="quiet"
          size="small"
          onClick={onCurrent}
          className="chiffre min-w-20"
          aria-label={`Week ${weekNum} — back to this week`}
        >
          Week {weekNum}
        </Button>
      )}
      <Button
        variant="quiet"
        size="icon-small"
        onClick={onNext}
        disabled={nextDisabled}
        aria-label="Next week"
      >
        <ChevronRight size={16} aria-hidden />
      </Button>
    </div>
  );
}
